import { createSelector } from '@reduxjs/toolkit'

import { TDashboardFilterOption } from 'types/GlobalDashboardFilter'

import { ApplicationState } from 'redux/Stores/types'

const selectResourceFilterStore = (state: ApplicationState) =>
  state.ResourceFilterStore

export const selectResourceFilterOptions = createSelector(
  [selectResourceFilterStore],
  (store): TDashboardFilterOption[] => store.options
)

export const selectResourceFilterOptionsMap = createSelector(
  [selectResourceFilterStore],
  (store): Record<string, TDashboardFilterOption> =>
    Object.fromEntries(store.options.map((o) => [o.attribute_id, o]))
)

export const selectResourceFilterData = createSelector(
  [selectResourceFilterStore],
  (store): { [attributeId: string]: string[] | undefined } => store.data
)

export const selectResourceFilterStatus = createSelector(
  [selectResourceFilterStore],
  (store): { fetched: boolean; fetching: boolean } => ({
    fetched: store.fetched,
    fetching: store.fetching
  })
)
